// extracted by mini-css-extract-plugin
export var container = "_su-0";
export var table = "_su-2";
export var tableWrapper = "_su-1";